var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root" },
    [
      _vm._t("top"),
      _vm._v(" "),
      _c("brick-circle-base", { attrs: { draggable: _vm.draggable } }, [
        _c("div", { staticClass: "brick-icon" }, [_vm._t("icon")], 2)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _c("label", [_vm._v(_vm._s(_vm.name))])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }